<template>
    <div class="d-flex flex-column align-items-center justify-content-center">
        <img src="/nodatafound.png" alt="" style="max-width: 100%; height: auto; max-height: 200px;" class="mb-3" />
        <h5 class="text-muted mb-1 fw-semibold">No Data Found</h5>
        <p class="text-secondary small mb-0">Try adjusting your search or filters to find what you're looking for.
        </p>
    </div>
</template>

<style scoped>
.text-muted {
    color: #6c757d !important;
}

.text-secondary {
    color: #adb5bd !important;
}

svg {
    opacity: 0.8;
    transition: transform 0.3s ease;
}

svg:hover {
    transform: scale(1.05);
    opacity: 1;
}
</style>